import { DatePicker } from '@sunwebgroup/uds-ui/date-picker'
import { format } from 'date-fns'
import * as React from 'react'
import { useIntl } from '@/intl'
import {
  golfDatesForFiltersSelector,
  golfEditingValueForSlotSelector,
} from '@/scopes/checkout/components/services/GolfService/selectors'
import {
  getGolfSlotIdBeingEdited,
  useGolfServiceStore,
} from '@/scopes/checkout/components/services/GolfService/store'
import { updateEditingGolfSlotDate } from '@/scopes/checkout/domain/actions'
import { useService } from '@/scopes/checkout/domain/hooks'
import { ServiceType } from '@/scopes/checkout/domain/types'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { parseGolfDateToISO } from '../helpers'

export function DateFilter() {
  const intl = useIntl()
  const { service, setServiceLocalValue } = useService(ServiceType.Golf)
  const slotId = useGolfServiceStore(getGolfSlotIdBeingEdited)
  const dateFormat = useConfiguration('dateFormat')

  const slot = golfEditingValueForSlotSelector(service, slotId ?? '')
  const availableDates = golfDatesForFiltersSelector(service, slot?.locationId ?? null, slot?.holes ?? null)

  if (!slotId)
    return null

  const minDate = availableDates.length > 0 ? new Date(availableDates[0]) : undefined
  const maxDate = availableDates.length > 0 ? new Date(availableDates[availableDates.length - 1]) : undefined
  const selectedDate = slot?.date ? new Date(slot.date) : availableDates.length > 0 ? new Date(availableDates[0]) : null

  return (
    <DatePicker
      label={intl.formatMessage({ id: 'checkout_steps_ancillaries_golf_date_label' })}
      value={selectedDate}
      minDate={minDate}
      maxDate={maxDate}
      calendarAriaLabel={intl.formatMessage({ id: 'date_picker_calendar_label' })}
      onChange={(date) => {
        if (!date) {
          setServiceLocalValue(updateEditingGolfSlotDate({ slotId, date: '' }))
          return
        }

        const dateString = format(date, dateFormat)
        setServiceLocalValue(updateEditingGolfSlotDate({ slotId, date: parseGolfDateToISO(dateString, dateFormat) }))
      }}
      dateFormat={dateFormat}
      helpText={dateFormat.toUpperCase()}
      locale={intl.locale}
    />
  )
}
